
import { Grid, Paper, Typography } from "@material-ui/core";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import LoadingSpinner from 'components/LoadingSpinner';
import { activityColors, activityStatusById, activityStatuses } from "features/activity/activityConsts";
import { useGetAllActivityItemsQuery } from "features/activity/activitySlice";
import FormatService from "services/formatService";
import { WorkOrderCardStyle } from "./WorkOrderCardStyle";
import WorkOrderActions from "./WorkOrderActions";
import AttachmentsTooltip from "features/attachments/AttachmentsTooltip";
import { AttachmentEntityTypes } from "features/attachments/attachmentsConsts";
import { NoteEntityTypes } from "features/notes/notesConsts";
import NotesTooltip from "features/notes/NotesTooltip";
import { loadStatuses, loadStatusesById } from "features/loads/enums";

const WorkOrderCard = ({ entity, isLoadingData, handleDone }) => {
    const classes = WorkOrderCardStyle();
    const loadMode = !entity?.workOrderId;

    let { data: activityItems, error: activityItemsError, isLoading: isLoadingActivityItems } = useGetAllActivityItemsQuery();

    const activityType = activityItems?.find(item => item.id == entity?.activityItemId);
    const status = entity?.activityId ?? entity?.latestStatus;
    const stillPending = status == activityStatuses.PendingClientApproval || status == loadStatuses.PENDING_PRICING_APPROVAL;

    const isLoading = () => {
        return isLoadingData || isLoadingActivityItems;
    }

    return (
        <>
            <div className={classes.divWrap}>
                <LoadingSpinner loading={isLoading()} />
                {entity && <Paper className={classes.card} style={{ borderStyle: 'solid', borderColor: `${activityColors[status]}`, borderWidth: stillPending ? '0 0 0 7px' : '2px 2px 2px 7px' }}>
                    <Grid container direction="row" alignItems="center" justifyContent="space-between" spacing={2} className={classes.container}>

                        <Grid item xs={8} className={classes.textWrapper}>
                            <div className={classes.wrapper}>
                                <Typography className={classes.lightText}>
                                    {entity?.clientName}
                                </Typography>

                                {stillPending && <Typography className={classes.lightText}>
                                    {loadMode ? FormatService.formatDateNoConversion(entity?.latestStatusDate) : FormatService.formatDateNoConversion(entity?.activityDate)}
                                </Typography>}
                            </div>

                            <Typography className={classes.regText}>
                                {loadMode ? 'Load Pricing' : 'Type of activity'}
                            </Typography>
                            <Typography className={classes.boldText}>
                                <Grid container direction="row" alignItems="center" spacing={1} justifyContent="space-between">
                                    <Grid item>
                                        {loadMode ? `VRID: ${entity?.id || '-'}` : activityType?.name ?? 'Unknown'}
                                    </Grid>
                                    {!loadMode && <Grid item>
                                        <AttachmentsTooltip entityType={AttachmentEntityTypes.ACTIVITY} entityId={entity?.id} />
                                        <NotesTooltip entityType={NoteEntityTypes.ACTIVITY} entityId={entity?.id} />
                                    </Grid>}
                                </Grid>
                            </Typography>
                            <Typography className={classes.regText}>
                                {`VIN: ${entity?.vinsForSearch ||entity?.vehicle?.descriptor || '-'}`}
                            </Typography>
                            <Typography className={classes.regText}>
                                {`Asset ID: ${entity?.externalId || entity?.vehicle?.assetId || '-'}`}
                            </Typography>
                            <Typography className={classes.regText}>
                                <div className={classes.indicatorWrapper}>
                                    <div item xs={2}>
                                        <div className={classes.indicator} style={{ background: loadMode ? '#FCC354' : activityColors[status] }}></div>
                                    </div>
                                    {loadMode ? loadStatusesById?.[status]?.name : activityStatusById?.[status]?.name} 
                                </div>
                            </Typography>
                            <Authorize profile={permissionProfiles.ACTIVITY.ACTIVITY_EDIT}>
                                <Typography className={classes.boldText}>
                                    Cost: ${loadMode ? entity?.loadPrice?.cost : entity?.price}
                                </Typography>
                            </Authorize>
                            <Typography className={classes.boldText}>
                                Price: ${loadMode ? entity?.loadPrice?.charge : entity?.revenue}
                            </Typography>
                        </Grid>

                        <WorkOrderActions 
                            entity={loadMode ? {...entity?.loadPrice, groupId: entity?.groupId} : entity} 
                            handleDone={handleDone} 
                            stillPending={stillPending} 
                            loadMode={loadMode} 
                        />
                    </Grid>
                </Paper>}
            </div>
        </>
    )
}

export default WorkOrderCard;